import {
  ActivityInboxBody,
  CLIENT_FILTERS,
} from "../../../components/notifications/ActivityInboxBody";

export default function ClientActivityInboxScreen() {
  return (
    <ActivityInboxBody
      theme="dark"
      filters={CLIENT_FILTERS}
      heroOverline="Inbox"
      heroTitle="Channel"
      heroEmphasis="activity"
      heroSubtitle="New submissions, candidate updates, judging events, and messages — every signal from your live programs in one place."
    />
  );
}
